import { formatValue } from '@utils/number';

type TShowAmountProps = {
  value: number;
  currency: string;
  maxDigits?: number;
};

export const showAmount = ({ value, currency, maxDigits = 2 }: TShowAmountProps): string => {
  return `${formatValue(value, currency, maxDigits)} ${currency}`;
};
